import { graphql } from 'react-relay';

export const pageFooterFragment = graphql`
    fragment PageFooter_siteFooter on SiteInfo {
        footer {
            ...SimpleLink_simpleLink
        }
    }
`;
